module.exports = __webpack_public_path__ + "static/img/fabrication_2.d73169b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrication_2.jpg
// module id = nVBE
// module chunks = 0